/* HHR v8.4: property finder uses Shopify permanent search route */
(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  let activeDialog = null;
  let dialogTrigger = null;

  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initLocalization();
    initDialogs();
    initGeneralFunnel();
    initPropertyFunnel();
    initListingForm();
    initPropertyGallery();
    enhanceProductDescription();
    initCollectionControls();
    initFinderForms();
    initLivePropertySearch();
  });

  function initMobileMenu() {
    const toggle = $('[data-menu-toggle]');
    const menu = $('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    document.addEventListener('click', (event) => {
      if (menu.hidden || event.target.closest('[data-site-header]')) return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    });
  }

  function initLocalization() {
    $$('[data-language-select]').forEach((select) => {
      select.addEventListener('change', () => select.form && select.form.submit());
    });
  }

  function initDialogs() {
    $$('[data-dialog-close]').forEach((button) => button.addEventListener('click', closeDialog));
    document.addEventListener('keydown', (event) => {
      if (!activeDialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
      }
      if (event.key === 'Tab') trapFocus(event, activeDialog);
    });

    const successDialog = $('.dialog-shell [data-form-success]')?.closest('.dialog-shell');
    if (successDialog) openDialog(successDialog, null);
  }

  function openDialog(dialog, trigger) {
    if (!dialog) return;
    activeDialog = dialog;
    dialogTrigger = trigger || document.activeElement;
    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dialog-open');
    window.requestAnimationFrame(() => {
      const first = $(focusableSelector, dialog);
      if (first) first.focus({ preventScroll: true });
    });
  }

  function closeDialog() {
    if (!activeDialog) return;
    const closing = activeDialog;
    activeDialog = null;
    closing.setAttribute('aria-hidden', 'true');
    closing.hidden = true;
    document.body.classList.remove('dialog-open');
    if (dialogTrigger && typeof dialogTrigger.focus === 'function') dialogTrigger.focus({ preventScroll: true });
    dialogTrigger = null;
  }

  function trapFocus(event, container) {
    const items = $$(focusableSelector, container).filter((item) => item.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initGeneralFunnel() {
    const dialog = $('[data-general-funnel]');
    if (!dialog) return;
    const form = $('#GeneralFunnelForm', dialog);
    const steps = $$('[data-general-step]', dialog);
    const bars = $$('.funnel-progress span', dialog);
    const count = $('[data-general-count]', dialog);
    const goalInput = $('[data-general-goal]', dialog);
    const timelineInput = $('[data-general-timeline]', dialog);
    const budgetInput = $('[data-general-budget]', dialog);
    let current = 1;

    const setStep = (number) => {
      current = Math.max(1, Math.min(4, number));
      steps.forEach((step) => {
        const active = Number(step.dataset.generalStep) === current;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      bars.forEach((bar, index) => bar.classList.toggle('is-active', index < current));
      if (count) count.textContent = current <= 3 ? `Question ${current} of 3` : 'Last step';
      const heading = $(`[data-general-step="${current}"] h3`, dialog);
      if (heading) heading.focus?.({ preventScroll: true });
    };

    const reset = () => {
      if (!form || $('[data-form-success]', form)) return;
      current = 1;
      [goalInput, timelineInput, budgetInput].forEach((input) => { if (input) input.value = ''; });
      $$('.choice-card', dialog).forEach((card) => card.classList.remove('is-selected'));
      setStep(1);
    };

    $$('[data-open-general-funnel]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        reset();
        openDialog(dialog, trigger);
      });
    });

    $$('[data-general-choice]', dialog).forEach((button) => {
      button.addEventListener('click', () => {
        const type = button.dataset.generalChoice;
        const value = button.dataset.value || '';
        $$(`[data-general-choice="${type}"]`, dialog).forEach((item) => item.classList.toggle('is-selected', item === button));
        if (type === 'goal' && goalInput) goalInput.value = value;
        if (type === 'timeline' && timelineInput) timelineInput.value = value;
        if (type === 'budget' && budgetInput) budgetInput.value = value;
        window.setTimeout(() => setStep(current + 1), 100);
      });
    });

    $$('[data-general-back]', dialog).forEach((button) => button.addEventListener('click', () => setStep(current - 1)));

    if (form) {
      form.addEventListener('submit', () => {
        const summary = $('[data-general-summary]', form);
        if (!summary) return;
        const details = $('[name="contact[Additional details]"]', form)?.value || 'Not supplied';
        const method = $('[name="contact[Preferred contact method]"]', form)?.value || 'Not supplied';
        summary.value = [
          'GENERAL WEBSITE ENQUIRY',
          `Goal: ${goalInput?.value || 'Not supplied'}`,
          `Timeline: ${timelineInput?.value || 'Not supplied'}`,
          `Budget direction: ${budgetInput?.value || 'Not supplied'}`,
          `Preferred contact method: ${method}`,
          `Additional details: ${details}`,
          `Page submitted from: ${window.location.href}`
        ].join('\n');
      });
    }
  }

  function initPropertyFunnel() {
    const dialog = $('[data-property-funnel]');
    if (!dialog) return;
    const form = $('#PropertyEnquiryForm', dialog);
    const steps = $$('[data-property-step]', dialog);
    const bars = $$('.funnel-progress span', dialog);
    const requestInput = $('[data-property-request-type]', dialog);
    const preferenceInput = $('[data-viewing-preference]', dialog);
    const timeValueInput = $('[data-viewing-time-value]', dialog);
    const dateChoice = $('[data-date-choice]', dialog);
    const dateInput = $('[data-viewing-date]', dialog);
    const timeRadios = $$('[name="viewing_time_ui"]', dialog);
    const submitButton = $('[data-property-submit]', dialog);
    const routeSummary = $('[data-property-route-summary]', dialog);
    let current = 1;
    let route = '';

    if (dateInput) dateInput.min = localDateAfterDays(3);

    const setStep = (number) => {
      current = Math.max(1, Math.min(3, number));
      steps.forEach((step) => {
        const active = Number(step.dataset.propertyStep) === current;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      bars.forEach((bar, index) => bar.classList.toggle('is-active', index < current));
    };

    const setRoute = (nextRoute) => {
      route = nextRoute;
      if (requestInput) requestInput.value = route;
      $$('[data-property-route]', dialog).forEach((button) => button.classList.toggle('is-selected', button.dataset.propertyRoute === route));
      if (submitButton) {
        const questionText = submitButton.dataset.questionText || 'Send property enquiry';
        const viewingText = submitButton.dataset.viewingText || 'Request this viewing';
        submitButton.firstChild.textContent = `${route === 'Viewing' ? viewingText : questionText} `;
      }
      updateRouteSummary();
    };

    const setViewingMode = (mode) => {
      if (preferenceInput) preferenceInput.value = mode;
      $$('[data-viewing-mode]', dialog).forEach((button) => button.classList.toggle('is-selected', button.dataset.viewingMode === mode));
      const needsDate = mode === 'Preferred date';
      if (dateChoice) dateChoice.hidden = !needsDate;
      if (dateInput) {
        dateInput.disabled = !needsDate;
        dateInput.required = needsDate;
        if (!needsDate) dateInput.value = '';
      }
      timeRadios.forEach((radio) => {
        radio.disabled = !needsDate;
        radio.required = needsDate;
        if (!needsDate) radio.checked = false;
      });
      if (!needsDate && timeValueInput) timeValueInput.value = '';
      updateRouteSummary();
    };

    const updateRouteSummary = () => {
      if (!routeSummary) return;
      if (route === 'Viewing') {
        const preference = preferenceInput?.value || 'Viewing timing not selected';
        const date = dateInput?.value ? formatDate(dateInput.value) : '';
        const time = timeValueInput?.value || '';
        routeSummary.textContent = preference === 'ASAP'
          ? 'Viewing request: as soon as possible. We will return with the earliest availability.'
          : `Viewing request: ${date || 'date to be selected'}${time ? `, ${time.toLowerCase()}` : ''}.`;
      } else {
        routeSummary.textContent = 'Property enquiry: availability, price or another detail about this exact listing.';
      }
    };

    const reset = () => {
      if (!form || $('[data-form-success]', form)) return;
      route = '';
      if (requestInput) requestInput.value = '';
      if (preferenceInput) preferenceInput.value = '';
      if (timeValueInput) timeValueInput.value = '';
      if (dateInput) { dateInput.value = ''; dateInput.disabled = true; dateInput.required = false; }
      timeRadios.forEach((radio) => { radio.checked = false; radio.disabled = true; radio.required = false; });
      if (dateChoice) dateChoice.hidden = true;
      $$('.choice-card', dialog).forEach((card) => card.classList.remove('is-selected'));
      setStep(1);
    };

    $$('[data-open-property-funnel]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        reset();
        const requested = trigger.dataset.requestType || '';
        if (requested === 'Viewing') { setRoute('Viewing'); setStep(2); }
        else if (requested === 'Question') { setRoute('Question'); setStep(3); }
        openDialog(dialog, trigger);
      });
    });

    $$('[data-property-route]', dialog).forEach((button) => {
      button.addEventListener('click', () => {
        setRoute(button.dataset.propertyRoute || 'Question');
        window.setTimeout(() => setStep(route === 'Viewing' ? 2 : 3), 100);
      });
    });

    $$('[data-viewing-mode]', dialog).forEach((button) => {
      button.addEventListener('click', () => {
        const mode = button.dataset.viewingMode || 'ASAP';
        setViewingMode(mode);
        if (mode === 'ASAP') window.setTimeout(() => setStep(3), 100);
      });
    });

    timeRadios.forEach((radio) => radio.addEventListener('change', () => {
      if (radio.checked && timeValueInput) timeValueInput.value = radio.value;
      updateRouteSummary();
    }));
    dateInput?.addEventListener('change', updateRouteSummary);

    $('[data-property-continue]', dialog)?.addEventListener('click', () => {
      if (!dateInput || !dateInput.value) { dateInput?.reportValidity(); return; }
      const selectedTime = timeRadios.find((radio) => radio.checked);
      if (!selectedTime) { timeRadios[0]?.reportValidity(); return; }
      if (timeValueInput) timeValueInput.value = selectedTime.value;
      updateRouteSummary();
      setStep(3);
    });

    $$('[data-property-back]', dialog).forEach((button) => button.addEventListener('click', () => {
      if (current === 3) setStep(route === 'Viewing' ? 2 : 1);
      else setStep(1);
    }));

    if (form) {
      form.addEventListener('submit', () => {
        const summary = $('[data-property-summary]', form);
        if (!summary) return;
        const value = (name) => $(`[name="${name}"]`, form)?.value || 'Not supplied';
        const preference = preferenceInput?.value || 'Not applicable';
        const date = dateInput?.value || 'Not applicable';
        const time = timeValueInput?.value || 'Not applicable';
        summary.value = [
          'SPECIFIC PROPERTY ENQUIRY',
          `Property: ${value('contact[Property]')}`,
          `Reference: ${value('contact[Property reference]')}`,
          `Listing type: ${value('contact[Listing type]')}`,
          `Advertised price: ${value('contact[Advertised price]')}`,
          `Property URL: ${value('contact[Property URL]')}`,
          `Request type: ${route || 'Question'}`,
          `Viewing preference: ${preference}`,
          `Preferred date: ${date}`,
          `Preferred time: ${time}`,
          `Preferred contact method: ${value('contact[Preferred contact method]')}`,
          `Questions or details: ${value('contact[Questions or details]')}`
        ].join('\n');
      });
    }
  }

  function localDateAfterDays(days) {
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + days);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function formatDate(value) {
    if (!value) return '';
    const [year, month, day] = value.split('-').map(Number);
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(year, month - 1, day, 12));
  }

  function initListingForm() {
    const form = $('#PropertyListingForm');
    if (!form || $('[data-form-success]', form)) return;
    const steps = $$('[data-listing-step]', form);
    const progress = $('[data-listing-progress]', form);
    const number = $('[data-listing-step-number]', form);
    let current = 1;

    const setStep = (next) => {
      current = Math.max(1, Math.min(4, next));
      steps.forEach((step) => {
        const active = Number(step.dataset.listingStep) === current;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      if (progress) progress.style.width = `${current * 25}%`;
      if (number) number.textContent = String(current);
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validateCurrent = () => {
      const step = $(`[data-listing-step="${current}"]`, form);
      if (!step) return true;
      for (const field of $$('input,select,textarea', step)) {
        if (!field.checkValidity()) { field.reportValidity(); return false; }
      }
      return true;
    };

    $$('[data-listing-next]', form).forEach((button) => button.addEventListener('click', () => {
      if (validateCurrent()) setStep(current + 1);
    }));
    $$('[data-listing-back]', form).forEach((button) => button.addEventListener('click', () => setStep(current - 1)));

    form.addEventListener('submit', () => {
      const summary = $('[data-listing-summary]', form);
      if (!summary) return;
      const lines = ['PROPERTY LISTING SUBMISSION'];
      $$('[name^="contact["]', form).forEach((field) => {
        if (field === summary || field.name === 'contact[body]' || field.name === 'contact[Enquiry source]') return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        const label = field.name.replace(/^contact\[/, '').replace(/\]$/, '');
        const value = field.type === 'checkbox' ? field.value : field.value.trim();
        if (value) lines.push(`${label}: ${value}`);
      });
      lines.push(`Submitted from: ${window.location.href}`);
      summary.value = lines.join('\n');
    });
  }

  function initPropertyGallery() {
    $$('[data-product-gallery]').forEach((gallery) => {
      const slides = $$('[data-gallery-slide]', gallery);
      const thumbs = $$('[data-gallery-thumb]', gallery);
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.galleryThumb || 0);
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((item, thumbIndex) => item.classList.toggle('is-active', thumbIndex === index));
      }));
    });
  }

  function enhanceProductDescription() {
    const source = $('[data-description-source]');
    if (!source || source.dataset.enhanced === 'true') return;
    const children = Array.from(source.children);
    const headingCount = children.filter((node) => /H[23]/.test(node.tagName)).length;
    if (headingCount < 2) return;

    const intro = document.createDocumentFragment();
    const details = [];
    let current = null;
    children.forEach((node) => {
      if (/H[23]/.test(node.tagName)) {
        current = document.createElement('details');
        current.className = 'description-panel';
        const summary = document.createElement('summary');
        summary.textContent = node.textContent.trim();
        const body = document.createElement('div');
        body.className = 'description-panel__body';
        current.append(summary, body);
        details.push(current);
      } else if (current) {
        $('.description-panel__body', current).appendChild(node);
      } else {
        intro.appendChild(node);
      }
    });
    source.replaceChildren(intro, ...details);
    if (details[0]) details[0].open = true;
    source.dataset.enhanced = 'true';
  }

  function initCollectionControls() {
    const filterToggle = $('[data-filter-toggle]');
    const filterWrap = filterToggle?.closest('.collection-filters');
    if (filterToggle && filterWrap) filterToggle.addEventListener('click', () => {
      const open = filterWrap.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });

    const sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.assign(url.toString());
    });

    const filterForm = $('[data-filter-form]');
    if (filterForm) {
      $$('input[type=checkbox]', filterForm).forEach((input) => input.addEventListener('change', () => filterForm.requestSubmit()));
      $$('input[type=number]', filterForm).forEach((input) => input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') filterForm.requestSubmit();
      }));
    }
  }

  function initFinderForms() {
    const params = new URLSearchParams(window.location.search);
    $$('[data-property-finder]').forEach((form) => {
      ['property_route', 'property_type', 'bedrooms', 'bathrooms', 'area', 'min_price', 'max_price', 'q'].forEach((name) => {
        const field = $(`[name="${name}"]`, form);
        if (field && params.has(name)) { const value = params.get(name) || ''; field.value = value === '*' ? '' : value; }
      });
      form.addEventListener('submit', () => {
        const query = $('[name="q"]', form);
        if (query && query.value.trim() === '*') query.value = '';
      });
    });
  }

  function initLivePropertySearch() {
    const root = $('[data-live-property-search]');
    if (!root) return;
    const results = $('[data-live-search-results]', root);
    const status = $('[data-live-search-status]', root);
    const params = new URLSearchParams(window.location.search);
    const route = params.get('property_route') || '';

    try {
      const records = $$('[data-property-record]', root).map((node) => JSON.parse(node.textContent));
      if (!records.length) throw new Error('No indexed property records were rendered');

      const deduped = new Map();
      records.forEach((product) => {
        if (!deduped.has(product.id)) deduped.set(product.id, { ...product, _routes: new Set() });
        deduped.get(product.id)._routes.add(product._route);
      });

      const indexed = Array.from(deduped.values()).filter((product) => {
        if (route && !product._routes.has(route)) return false;
        return matchesProperty(product, params);
      });

      renderSearchResults(indexed, results, route);
      if (status) {
        status.innerHTML = '';
        const paragraph = document.createElement('p');
        paragraph.textContent = indexed.length === 1 ? '1 matching property' : `${indexed.length} matching properties`;
        status.appendChild(paragraph);
      }
    } catch (error) {
      console.warn('Rendered property index error:', error);
      if (status) status.innerHTML = '<p>The property index could not load. Please refresh the page or use the guided enquiry.</p>';
      renderSearchResults([], results, route);
    }
  }

  function matchesProperty(product, params) {
    const searchable = propertySearchText(product);
    const type = normalizeSearchValue(params.get('property_type'));
    const area = normalizeSearchValue(params.get('area'));
    let keyword = normalizeSearchValue(params.get('q'));
    if (keyword === '*') keyword = '';

    const bedrooms = Number(params.get('bedrooms') || 0);
    const bathrooms = Number(params.get('bathrooms') || 0);
    const minPrice = Number(params.get('min_price') || 0);
    const maxPrice = Number(params.get('max_price') || 0);
    const price = minimumProductPrice(product);

    if (type && !matchesPropertyType(searchable, type)) return false;
    if (area && !matchesArea(searchable, area)) return false;
    if (keyword && !matchesKeyword(searchable, keyword)) return false;

    if (bedrooms) {
      const found = extractPropertyCount(searchable, ['bedroom', 'bedrooms', 'bed', 'beds', 'br']);
      if (found === null || found < bedrooms) return false;
    }

    if (bathrooms) {
      const found = extractPropertyCount(searchable, ['bathroom', 'bathrooms', 'bath', 'baths']);
      if (found === null || found < bathrooms) return false;
    }

    if (minPrice && price < minPrice) return false;
    if (maxPrice && price > maxPrice) return false;
    return true;
  }

  function propertySearchText(product) {
    const html = stripHtml(product.body_html || '');
    const tags = Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '');
    const options = Array.isArray(product.options)
      ? product.options.map((option) => `${option.name || ''} ${(option.values || []).join(' ')}`).join(' ')
      : '';
    const variants = Array.isArray(product.variants)
      ? product.variants.map((variant) => `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`).join(' ')
      : '';
    return normalizeSearchValue(`${product.title || ''} ${html} ${product.product_type || ''} ${product.vendor || ''} ${tags} ${options} ${variants}`);
  }

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[–—-]/g, ' ')
      .replace(/[^a-z0-9.+\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function matchesPropertyType(text, requestedType) {
    const aliases = {
      villa: ['villa', 'pool villa', 'private pool'],
      condo: ['condo', 'condominium', 'apartment'],
      house: ['house', 'detached home', 'home'],
      townhouse: ['townhouse', 'town house', 'townhome'],
      land: ['land', 'plot', 'land plot']
    };
    const values = aliases[requestedType] || [requestedType];
    return values.some((value) => hasSearchPhrase(text, value));
  }

  function matchesArea(text, requestedArea) {
    const aliases = {
      'central hua hin': ['central hua hin', 'hua hin centre', 'hua hin center', 'downtown hua hin', 'central'],
      'hin lek fai': ['hin lek fai', 'hin lekfai'],
      'thap tai': ['thap tai', 'thaptai'],
      'khao takiab': ['khao takiab', 'takiab'],
      'khao tao': ['khao tao', 'khaotao'],
      'black mountain': ['black mountain'],
      'palm hills': ['palm hills', 'palm hill'],
      'cha am': ['cha am', 'chaam'],
      pranburi: ['pranburi', 'pran buri']
    };
    const values = aliases[requestedArea] || [requestedArea];
    return values.some((value) => hasSearchPhrase(text, value));
  }

  function matchesKeyword(text, keyword) {
    const phrase = normalizeSearchValue(keyword);
    if (!phrase) return true;
    if (hasSearchPhrase(text, phrase)) return true;
    const terms = phrase.split(' ').filter((term) => term.length > 1);
    return terms.every((term) => hasSearchPhrase(text, term));
  }

  function hasSearchPhrase(text, phrase) {
    const normalized = normalizeSearchValue(phrase);
    if (!normalized) return true;
    return (` ${text} `).includes(` ${normalized} `) || text.includes(normalized);
  }

  function extractPropertyCount(text, words) {
    const names = words.join('|');
    const patterns = [
      new RegExp(`(?:${names})\\s*[:x-]?\\s*(\\d+(?:\\.\\d+)?)\\b`, 'i'),
      new RegExp(`\\b(\\d+(?:\\.\\d+)?)\\s*[- ]?(?:${names})\\b`, 'i'),
      new RegExp(`\\b(\\d+(?:\\.\\d+)?)\\s*\\+\\s*(?:${names})?`, 'i')
    ];
    for (const pattern of patterns) {
      const match = text.match(pattern);
      if (match) return Number(match[1]);
    }
    return null;
  }

  function stripHtml(value) {
    const template = document.createElement('template');
    template.innerHTML = value;
    return template.content.textContent || '';
  }

  function renderSearchResults(products, container, requestedRoute) {
    if (!container) return;
    container.replaceChildren();
    if (!products.length) {
      const empty = document.createElement('div');
      empty.className = 'empty-state';
      const heading = document.createElement('h2');
      heading.textContent = 'No properties match every selected detail.';
      const copy = document.createElement('p');
      copy.textContent = 'Broaden one filter or use the guided enquiry so we can check suitable alternatives.';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--primary';
      button.textContent = 'Start a guided enquiry';
      button.addEventListener('click', () => $('[data-open-general-funnel]')?.click());
      empty.append(heading, copy, button);
      container.appendChild(empty);
      return;
    }

    products.forEach((product) => {
      const card = document.createElement('article');
      card.className = 'property-card';
      const mediaLink = document.createElement('a');
      mediaLink.className = 'property-card__media';
      mediaLink.href = `/products/${encodeURIComponent(product.handle)}`;
      const imageSource = product.images?.[0]?.src || product.image?.src;
      if (imageSource) {
        const image = document.createElement('img');
        image.src = imageSource;
        image.alt = product.title || 'Hua Hin property';
        image.loading = 'lazy';
        mediaLink.appendChild(image);
      }
      const routes = product._routes || new Set();
      const label = routes.size > 1 ? 'For sale & rent' : routes.has('rent') ? 'For rent' : 'For sale';
      const badge = document.createElement('span');
      badge.className = 'property-card__badge';
      badge.textContent = label;
      mediaLink.appendChild(badge);

      const body = document.createElement('div');
      body.className = 'property-card__body';
      if (product.product_type) {
        const type = document.createElement('p');
        type.className = 'property-card__type';
        type.textContent = product.product_type;
        body.appendChild(type);
      }
      const title = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = mediaLink.href;
      titleLink.textContent = product.title;
      title.appendChild(titleLink);
      const footer = document.createElement('div');
      footer.className = 'property-card__footer';
      const price = document.createElement('strong');
      price.textContent = formatMoney(minimumProductPrice(product)) + (label === 'For rent' ? ' / month' : '');
      const details = document.createElement('a');
      details.className = 'property-card__link';
      details.href = mediaLink.href;
      details.textContent = 'View details →';
      footer.append(price, details);
      body.append(title, footer);
      card.append(mediaLink, body);
      container.appendChild(card);
    });
  }

  function minimumProductPrice(product) {
    if (Number.isFinite(Number(product.price)) && Number(product.price) > 0) {
      return Number(product.price) / 100;
    }
    const prices = Array.isArray(product.variants)
      ? product.variants.map((variant) => Number(variant.price || 0)).filter((price) => Number.isFinite(price) && price > 0)
      : [];
    return prices.length ? Math.min(...prices) : 0;
  }

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'THB', maximumFractionDigits: 0 }).format(value).replace('THB', '').trim();
    } catch (_) {
      return `฿${Math.round(value).toLocaleString()}`;
    }
  }
})();


/* V8.1: keep property submissions out of the general enquiry funnel.
   This also catches legacy List a property cards retained by cached Shopify markup. */
document.addEventListener('click', function (event) {
  var dialog = event.target.closest('[data-general-funnel]');
  if (!dialog) return;

  var directRoute = event.target.closest('[data-list-property-route]');
  var legacyChoice = event.target.closest('[data-general-choice]');
  var legacyValue = legacyChoice ? String(legacyChoice.getAttribute('data-value') || legacyChoice.textContent || '').toLowerCase() : '';

  if (directRoute || legacyValue.indexOf('list a property') !== -1 || legacyValue.indexOf('list your property') !== -1) {
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(dialog.getAttribute('data-list-property-url') || '/pages/list-your-hua-hin-properties-for-free');
  }
}, true);
